/**
 * Single source of truth for the KONE Flow Design System color tokens used
 * across this plugin. Copied verbatim from
 * backstage/plugins/business_applications/src/components/details/koneColors.ts
 * so both plugins render the exact same palette — this plugin is
 * intentionally independent (own package, own routes, no dependency on
 * @internal/backstage-plugin-business-applications), so the tokens are duplicated
 * here rather than imported cross-plugin. If a third plugin needs them,
 * consider extracting a shared `@internal/kone-design-tokens` package
 * instead of a third copy.
 *
 * See the Business Applications copy's docstring for the full palette
 * rationale (approved KONE Flow Design System colors only, no purple, no
 * invented one-off shades).
 */
export const KONE_ROOT_VARS = `
  --kone-blue: #1450F5;
  --kone-blue-light: #4373F7;
  --kone-white: #FFFFFF;
  --kone-black: #141414;
  --kone-sand: #F3EEE6;
  --kone-yellow: #FFE141;
  --kone-light-blue: #D2F5FF;
  --kone-pink: #FFCDD7;
  --kone-green: #AAE1C8;
  --kone-success: #1ED273;
  --kone-warning: #FFA023;
  --kone-error: #FF5F28;
  --kone-neutral-2: #434343;
  --kone-neutral-3: #727272;
  --kone-neutral-4: #A1A1A1;
  --kone-neutral-5: #D0D0D0;
  --kone-surface: #FFFFFF;
  --kone-surface-alt: #F8FAFC;
  --kone-border: #E7EBF0;
  --kone-text: #141414;
  --kone-text-muted: rgba(20, 20, 20, 0.72);
  --kone-radius: 12px;
  --kone-shadow: 0 8px 24px rgba(20, 80, 245, 0.08);
`;
